module.exports = __webpack_public_path__ + "c753214a43df6e43f070cfdd096ffee2.svg";